import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'tabs-header',
    templateUrl: './tabs-header.html',
    styleUrls: ['./tabs-header.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsHeaderComponent {}
